import { render, staticRenderFns } from "./CommentsCounter.vue?vue&type=template&id=222536ab&"
import script from "./CommentsCounter.vue?vue&type=script&lang=js&"
export * from "./CommentsCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports